import React from "react";

// List of dentist service field keys (the ones stored in clinic object)
const DENTIST_SERVICE_KEYS = [
  "generalDentistry",
  "cosmeticDentistry",
  "dentalCheckUp",
  "restorationAndFilling",
  "crownsAndBridges",
  "fractureAndTrauma",
  "vaneersAndLaminates",
  "extraction",
  "oralAndMaxillofacialSurgery",
  "orthodonticsTreatment",
  "childDentistry",
  "implant",
  "scalingAndTeethCleaning",
  "rootCanalTreatment",
];

// Helper to format key name
const formatKeyName = (key) => {
  // Convert camelCase to Title Case with spaces
  const formatted = key
    .replace(/([A-Z])/g, " $1")
    .trim()
    .replace("Surgery", "Surg.")
    .replace(/\b\w/g, (char) => char.toUpperCase());
  return formatted;
};

const DetailService = ({ clinic, reset, onCheckAppointments }) => {
  // If clinic is not provided, show error
  if (!clinic) {
    return (
      <div
        id="login-popup"
        tabIndex="-1"
        className="bg-black/50 fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden"
      >
        <div className="relative p-4 w-full max-w-xl h-full md:h-auto">
          <div className="relative bg-white rounded-lg shadow p-5 text-center">
            <p className="text-red-500">No clinic data provided.</p>
            <button
              type="button"
              className="mt-4 bg-gray-300 px-4 py-2 rounded-lg"
              onClick={reset}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Extract service fields from clinic object
  const transformedData = DENTIST_SERVICE_KEYS.filter((key) => key in clinic)
    .map((key) => ({
      name: formatKeyName(key),
      value: clinic[key] || 0,
    }))
    .filter((item) => item.value > 0); // only show services with charges > 0

  const clinicId = clinic.id;

  return (
    <div
      id="login-popup"
      tabIndex="-1"
      className="bg-black/50 fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden"
    >
      <div className="relative p-4 w-full max-w-xl h-full md:h-auto">
        <div className="relative bg-white rounded-lg shadow">
          <button
            type="button"
            className="absolute top-3 right-2.5 text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto"
            onClick={reset}
            aria-label="Close popup"
          >
            <svg
              className="w-5 h-5"
              fill="#c6c7c7"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
          <div className="p-5 text-center">
            <p className="mb-3 text-2xl font-semibold text-slate-900">
              Services & Charges
            </p>

            {transformedData.length > 0 ? (
              <div className="grid grid-cols-2 gap-1 border border-gray-300 p-2 rounded-lg my-2">
                {transformedData.map((service, index) => (
                  <div key={index} className="flex border-gray-200 py-2">
                    <span className="text-gray-500">{service.name}</span>
                    <span className="ml-auto text-gray-900">
                      ₹ {service.value}
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <p className="mb-3 text-lg text-left text-slate-900">
                No Services Selected
              </p>
            )}

            <button
              type="button"
              className="bg-teal-600 w-full text-white py-2 border border-gray-300 rounded-lg"
              onClick={() => onCheckAppointments(clinicId)}
            >
              Check Appointments
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailService;